<template>
    <div id="content">
        <section class="content-player-wrap">
            <div v-show="content_type=='video'" class="content-player__area">
                <video id="video01" class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" data-setup="{}" controls preload="auto" playsinline></video>
            </div>
            <div v-show="content_type=='music'" class="content-player__area">
                <audio class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" data-setup="{}" controls preload="auto" :poster="'/item/image/'+item_id" id="audio-player" playsinline>
                </audio>
            </div>
            <div class="content-player__data flex">
                <p class="play__title">{{ item_title }}<span class="post-date">{{ content_title }}</span></p>
            </div>
            <div class="cnt_wrap">
                <div class="fev_addition" v-if="contents.length" :class="{ 'fev_del': contents[playing_number].favorite_status==1 }">
                    <button v-if="contents[playing_number].favorite_status==0" @click="addFavoriteList(playing_number)"><span>お気に入り登録</span></button>
                    <button v-if="contents[playing_number].favorite_status==1" @click="removeFavoriteList(playing_number)"><span>お気に入り削除</span></button>
                </div>
                <div class="fev_addition rep_addition" :class="{ 'rep_del': repeat_flag }">
                    <button @click="changeRepeatFlag"><span>リピート</span></button>
                </div>
                <div class="fev_addition auto_addition" :class="{ 'auto_del': auto_play_flag }">
                    <button @click="changeAutoPlayFlag"><span>自動再生</span></button>
                </div>
            </div>
        </section>

        <section class="content-connection-blc">
            <div class="connection-head flex"><h3><span>関連音声</span></h3></div>
            <div class="acv-list-area">
                <article v-for="(random_voice, index) in random_voice_list" :key="index" v-show="loaded_list.indexOf(index) !== -1">
                    <a :href="'/purchased/player/'+random_voice.digicon_id+'?category1='+category1+'&category2='+category2" class="cvr"></a>
                    <p class="acv-thumb"><img :src="'/item/image/'+random_voice.item_id" alt="" @load="addImageLoadedList(index)"></p>
                    <p class="date">
                        <span class="play-btn">
                            <img src="/image/tmariko_template/positivesalon/positivesalon/play.svg">
                        </span>
                        <span class="up-v">{{ random_voice.up }}</span>
                        <span class="title-v">{{ random_voice.title }}</span>
                    </p>
                </article>
            </div>
        </section>
    </div><!---end/#content-->
</template>

<script>
    import 'video.js/dist/video-js.css';
    import videojs from 'video.js/dist/video.js';
    export default {
        name: "positivesalon-audio-player",
        props: {
            item_id: {
                type: String,
                default: '0',
            },
            digicon_id: {
                type: String,
            },
            category1: {
                type: String,
                default: '',
            },
            category2: {
                type: String,
                default: '',
            },
            fav_trans_flag: {
                type: Number,
                default: 0,
            },
            next_content_id: {
                type: Number,
                default: 0,
            },
            def_auto_play_flag: {
                type: Number,
                default: 0,
            },
        },
        data: function () {
            return {
                voice: undefined,
                content_title: '',
                item_title: '',
                contents: [],
                playing_number: Number,
                getAlbumInfoPath: '',
                getContentInfoPath: '',
                playStartSec: 0,
                repeat_flag: false,
                recordedFlag: false,
                finFlag: false,
                sample_flag: 0,
                loaded_list: [],
                random_voice_list: [],
                auto_play_flag: false,
                next_item_id: 0,
                next_digicon_id: 0,
                content_type: '',
            }
        },
        created() {
            this.auto_play_flag = this.def_auto_play_flag==1?true:false;
        },
        mounted() {
            this.getAlbumInfoPath = '/purchased/digicon/detail/'+this.item_id;
            this.getContentInfoPath = '/digicon/content/';

            this.voice = videojs("audio-player", {html5: {
                }},
            );

            this.setMusicConfig();
            axios.default
                .post(this.getAlbumInfoPath, {type: 'content'})
                .then(response => {
                    let contents = response.data;
                    for(let i=0; i<contents.length; i++) {
                        this.$set(this.contents, i, contents[i]);
                    }
                    this.jump(this.digicon_id);
                    this.getNextContentInfo();
            });

            this.getRandomMusicList();
        },
        methods: {
            play: function() {
                if(this.finFlag) {
                    this.finFlag = false;
                    this.playing_number = 0;
                    this.setDigicon(this.playing_number);
                    return;
                }
                this.voice.play();
                this.resetPlayingSec();
            },
            stop: function() {
                this.voice.pause();
            },
            setMusicConfig: function() {
                this.voice.on('loadedmetadata', function() {
                    this.recordedFlag = false;
                    this.recordContentsPlayLog();
                    this.play();
                }.bind(this));
                this.voice.on('timeupdate', function() {
                    this.recordPlayLog();
                }.bind(this));
                this.voice.on('ended', function() {
                    this.forward();
                }.bind(this));
            },
            setDigiconConfig: function(path) {
                this.voice.src(path);
            },
            setDigicon: function(playing_number) {
                if(this.contents.length <= playing_number) {
                    this.playing_number = 0;
                    playing_number = this.playing_number;
                }
                this.content_title = this.contents[playing_number].title;
                let digicon_id = this.contents[playing_number].digicon_id;
                this.item_title = this.contents[playing_number].item_title;
                this.content_type = this.contents[playing_number].type;
                axios.default
                    .get(this.getContentInfoPath+digicon_id)
                    .then(response => {
                        let data = response.data;
                        let playing_path = data.fname;
                        this.setDigiconConfig(playing_path);
                    });
            },
            getNextContentInfo: function() {
                axios.default
                    .get(`/next_play/digicon_id/get?digicon_id=${this.digicon_id}&${this.category_query}&fav_trans_flag=${this.fav_trans_flag}`)
                    .then(response => {
                        let ret = response.data;
                        this.next_item_id = ret.item_id;
                        this.next_digicon_id = ret.digicon_id;
                });
            },
            getAlbumInfo: function() {
                axios.default
                    .post('/purchased/digicon/detail/'+this.item_id, {type: 'content'})
                    .then(response => {
                        let contents = response.data;
                        // for(let i=0; i<contents.length; i++) {
                        //     // this.$set(this.contents, i, contents[i]);
                        // }
                        this.contents = contents;
                        this.jump(this.digicon_id);
                        this.getNextContentInfo();
                });
            },
            forward: function() {
                this.stop();
                if(this.repeat_flag !== true) {
                    if(this.contents.length-1 <= this.playing_number) {
                        this.finFlag = true;
                        // if(this.auto_play_flag && this.next_content_id!=0) {
                        //     const url='/purchased/player/'+this.next_content_id+'?category1='+this.category1+'&category2='+this.category2+'&fav_trans_flag='+this.fav_trans_flag+'&auto_play_flag=1';
                        //     window.location.href = url;
                        // }
                        if(this.auto_play_flag && this.next_item_id!=0) {
                            console.log(`item_id=${this.item_id}, next_item_id=${this.next_item_id}`);
                            console.log(`digicon_id=${this.digicon_id}, next_digicon_id=${this.next_digicon_id}`);
                            this.item_id = Number(this.next_item_id);
                            this.digicon_id = Number(this.next_digicon_id);
                            this.getAlbumInfo();
                        }
                        return;
                    } else {
                        this.playing_number++;
                    }
                }
                this.setDigicon(this.playing_number);
            },
            jump: function(digicon_id) {
                this.stop();
                let index = 0;
                for(let content of this.contents) {
                    if(content.digicon_id == digicon_id) {
                        this.playing_number = index;
                        this.setDigicon(this.playing_number);
                        break;
                    }
                    index++;
                }
            },
            changeRepeatFlag: function() {
                this.repeat_flag = (this.repeat_flag)?false:true;
            },
            changeAutoPlayFlag: function() {
                this.auto_play_flag = (this.auto_play_flag)?false:true;
            },
            resetPlayingSec: function() {
                this.playStartSec = performance.now();
            },
            recordPlayLog: function() {
                if(!this.checkPlayingSec()) return;
                if(this.recordedFlag) return;
                this.recordedFlag = true;
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .post('/player/log/add', {digicon_id: digicon_id})
                    .then(response => {
                        if(response.data.status=='error') {
                            this.recordedFlag = false;
                        }
                    });
            },
            recordContentsPlayLog: function() {
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .get('/playlog/content/add/'+digicon_id, {sample_flag: this.sample_flag})
                    .then(response => {
                        if(!response.data[0].log_id) {
                            console.log('fail record playlog');
                        }
                    });
            },
            checkPlayingSec: function() {
                if(performance.now() - this.playStartSec < 46000) return false;
                return true;
            },
            addFavoriteList: function(index) {
                let digicon_id = this.contents[index]['digicon_id'];
                axios.default
                    .get('/favorite/content/add/'+digicon_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 1;
                        this.contents[index]['favorite_id'] = res.favorite_id;
                    });
            },
            removeFavoriteList: function(index) {
                let favorite_id = this.contents[index]['favorite_id'];
                axios.default
                    .get('/favorite/content/remove/'+favorite_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 0;
                        this.contents[index]['favorite_id'] = undefined;
                    });
            },
            getRandomMusicList: function() {
                axios.default
                    .get('/voice/get/random?item_id='+this.item_id+'&category1='+this.category1+'&category2='+this.category2)
                    .then(response => {
                        this.random_voice_list = response.data;
                    });
            },
            addImageLoadedList: function(index) {
                this.loaded_list.push(index);
            },
        },
    }
</script>

<style scoped>
</style>
